__turbopack_context__.v({
  "headerCloseButton": "YsVwWG_headerCloseButton",
  "headerContainer": "YsVwWG_headerContainer",
  "headerInformation": "YsVwWG_headerInformation",
  "headerInformationTags": "YsVwWG_headerInformationTags",
  "headerInnerContainer": "YsVwWG_headerInnerContainer",
  "headerTop": "YsVwWG_headerTop",
  "headerTopActions": "YsVwWG_headerTopActions",
  "headerTopLoader": "YsVwWG_headerTopLoader",
  "headerTopTitle": "YsVwWG_headerTopTitle",
  "middot": "YsVwWG_middot",
  "orderFormat": "YsVwWG_orderFormat",
  "serviceTime": "YsVwWG_serviceTime",
});
